
/**Auth*/
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const LOGOUT = 'LOGOUT'
export const SET_USER = 'SET_USER'

export const SET_ADDRESSES = 'SET_ADDRESSES'
export const SET_SERVED_BY = 'SET_SERVED_BY'

/**Media*/
export const SET_USER_UPLOADS = 'SET_USER_UPLOADS'


/**Product*/
export const SET_ALL_PRODUCTS = 'SET_ALL_PRODUCTS'
export const SET_PRODUCT_STOCK = 'SET_PRODUCT_STOCK'
export const SET_ALL_CATEGORIES = 'SET_ALL_CATEGORIES'

/**Post*/
export const SET_POSTS = 'SET_POSTS'
export const UPDATE_FS_GALLERY_STATUS = 'UPDATE_FS_GALLERY_STATUS'

/**Customer*/
export const REPLACE_CUSTOMER = 'REPLACE_CUSTOMER'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_CREATECUSTOMER_PREFILL = 'SET_CREATECUSTOMER_PREFILL'
export const CLEAR_CREATECUSTOMER_PREFILL = 'CLEAR_CREATECUSTOMER_PREFILL'
export const SET_CREATEHOST_DATEANDDATA = 'SET_CREATEHOST_DATEANDDATA'
export const CLEAR_FILTER_TAG = 'CLEAR_FILTER_TAG'
export const ACTIVATE_FILTER_TAG = 'ACTIVATE_FILTER_TAG'
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'
export const UPDATE_ALL_TAGS_STATUSES = 'UPDATE_ALL_TAGS_STATUSES'
export const OPEN_FILTERPAGE = 'OPEN_FILTERPAGE'
export const CLOSE_FILTERPAGE = 'CLOSE_FILTERPAGE'
export const OPEN_MERGEFORM = 'OPEN_MERGEFORM'
export const MERGE_PICKTARGET = 'MERGE_PICKTARGET'
export const CLOSE_MERGEFORM = 'CLOSE_MERGEFORM'
export const MERGING_STATUS_ENABLE = 'MERGING_STATUS_ENABLE'
export const MERGING_STATUS_DISABLE = 'MERGING_STATUS_DISABLE'
export const OPEN_SMSFORM = 'OPEN_SMSFORM'
export const OPEN_EMAILFORM = 'OPEN_EMAILFORM'
export const CLOSE_MESSAGEFORM = 'CLOSE_MESSAGEFORM'

/**Dealers*/
export const SET_DEALERS = 'SET_DEALERS'
export const SET_AVAILABLE_TAGS = 'SET_AVAILABLE_TAGS'
export const SET_ALL_KICKBACKLOG = 'SET_ALL_KICKBACKLOG'

/**Order*/
export const SET_ORDERS = 'SET_ORDERS'
export const SET_INVOICES = 'SET_INVOICES'
export const SET_OPEN_ORDER = 'SET_OPEN_ORDER'
export const SET_DEALERS_CUSTLIST = 'SET_DEALERS_CUSTLIST'

/**Party*/
export const SET_PARTIES = 'SET_PARTIES'
export const SET_CALENDAR_DATES = 'SET_CALENDAR_DATES'
export const REPLACE_PARTY = 'REPLACE_PARTY'
export const SET_ACTIVE_PARTY = 'SET_ACTIVE_PARTY'
export const START_UPDATING_CART_QUANTITY = 'START_UPDATING_CART_QUANTITY'
export const DONE_UPDATING_CART_QUANTITY = 'DONE_UPDATING_CART_QUANTITY'
export const START_ADDING_PARTICIPANT = 'START_ADDING_PARTICIPANT'
export const DONE_ADDING_PARTICIPANT = 'DONE_ADDING_PARTICIPANT'
export const SET_DEALER = 'SET_DEALER'

/*backorders*/
export const SET_ALL_BACKORDERS = 'SET_ALL_BACKORDERS'

/**Group*/
export const SET_ALL_SCORELOGS = 'SET_ALL_SCORELOGS'
export const SET_ALL_TEAMMEMBERS = 'SET_ALL_TEAMMEMBERS'
export const SET_ALL_TEAMTHISWEEK = 'SET_ALL_TEAMTHISWEK'
export const SET_ALL_TEAMTRIPDATA = 'SET_ALL_TEAMTRIPDATA'
export const SET_ALL_ADMINTRIPDATA = 'SET_ALL_ADMINTRIPDATA'
export const SET_ALL_TEAMCAMPAIGNDATA = 'SET_ALL_TEAMCAMPAIGNDATA'
export const SET_GROUPMEMBERSCORE = 'SET_GROUPMEMBERSCORE'
export const SET_GROUPMEMBERDEALER = 'SET_GROUPMEMBERDEALER'
export const CLEAR_MESSAGES_PRESELECTION = 'CLEAR_SMS_PRESELECTION'
export const SAVE_MESSAGES_PRESELECTION = 'SAVE_SMS_PRESELECTION'
export const GET_TOPTENSCORE = 'GET_TOPTENSCORE'

/**Menu*/
export const CLOSE_MENU = 'CLOSE_MENU'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const UPDATE_OVERLAY_ACTIVE = 'UPDATE_OVERLAY_ACTIVE'
export const UPDATE_CUSTOM_POPUP_STATE = 'UPDATE_CUSTOM_POPUP_STATE'

/**Returns*/
export const SET_MAP = 'SET_MAP'
export const SET_CLAIMS = 'SET_CLAIMS'
export const SET_ADMIN_PENDING_CLAIMS = 'SET_CLAIMS'

/** Profiles **/
export const SET_PROFILE  = 'SET_PROFILE'
export const SET_PROFILES = 'SET_PROFILES'
export const SET_PROFILE_DRAFT  = 'SET_PROFILE_DRAFT'
export const SET_PROFILE_DRAFTS = 'SET_PROFILE_DRAFTS'

/** Campaigns **/
export const SET_ALL_CAMPAIGNS  = 'SET_ALL_CAMPAIGNS'

/** Notifications **/
export const SET_ALL_NOTIFICATIONS  = 'SET_ALL_NOTIFICATIONS'
